import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { fetchSystemStatus } from './api';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Indicators from './pages/Indicators';
import Strategies from './pages/Strategies';
import StrategyDetail from './pages/StrategyDetail';
import Backtest from './pages/Backtest';
import TradeHistory from './pages/TradeHistory';
import Settings from './pages/Settings';
import ManualTrade from './pages/ManualTrade';
import RollingStrangle from './pages/RollingStrangle';
import Positions from './pages/Positions';
import OptionChain from './pages/OptionChain';
import './App.css';

const REFRESH_INTERVAL = 15000;

function OAuthHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authSuccess = params.get('auth_success');
    const authError = params.get('auth_error');
    if (authSuccess || authError) {
      window.history.replaceState({}, '', location.pathname);
      const msg = authSuccess
        ? `AngelOne account ${authSuccess} connected via OAuth!`
        : `AngelOne login failed: ${authError}`;
      navigate('/settings', { state: { authMessage: msg, authOk: !!authSuccess } });
    }
  }, [location, navigate]);

  return null;
}

function AppShell() {
  const [systemStatus, setSystemStatus] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [cycleCount, setCycleCount] = useState(0);

  const pollStatus = useCallback(async () => {
    try {
      const res = await fetchSystemStatus();
      if (res.data) {
        setSystemStatus(res.data);
        setCycleCount(res.data.cycle_count || 0);
        setLastUpdate(res.data.last_update || new Date().toLocaleTimeString());
      }
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    pollStatus();
    const id = setInterval(pollStatus, REFRESH_INTERVAL);
    return () => clearInterval(id);
  }, [pollStatus]);

  return (
    <div className="app">
      <OAuthHandler />
      <Sidebar systemStatus={systemStatus} cycleCount={cycleCount} lastUpdate={lastUpdate} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/indicators" element={<Indicators />} />
          <Route path="/strategies" element={<Strategies />} />
          <Route path="/strategies/:name" element={<StrategyDetail />} />
          <Route path="/manual-trade" element={<ManualTrade />} />
          <Route path="/rolling-strangle" element={<RollingStrangle />} />
          <Route path="/positions" element={<Positions />} />
          <Route path="/option-chain" element={<OptionChain />} />
          <Route path="/backtest" element={<Backtest />} />
          <Route path="/trade-history" element={<TradeHistory />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
